import { Grid } from "@mui/material";
import { ReactComponent as CopyLink } from "assets/copy_link.svg";
import CopySection from "assets/FileAdd.svg";
import {
  clearSelectedCards,
  setActiveActionCard,
  setCopyActionPopupEnabled,
  setSelectedCards
} from "components/app/App.slice";
import Button from "components/common/Button";
import CheckBox from "components/common/Checkbox";
import Feedback from "components/common/Feedback";
import KebabMenu from "components/common/KebabMenu";
import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import { useContext, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes, FEEDBACK_TIMER } from "utils/CommonConstants";
import { getHoursAndMin } from "utils/CommonFunctions";
import { planTypes } from "utils/Types";
import { REDIRECT_URI } from "utils/URLConstants";
import ActionCardDialogsContext from "./Context";

interface Props {
  timeEstimateMinutes: string;
  title: string;
  multiCardSelect: boolean;
  item: any;
  sectionId?: any;
  planId?: any;
}

function AllPlans(props: Props) {
  const { id }: any = useParams();
  const dispatch = useAppDispatch();
  const { timeEstimateMinutes, title, multiCardSelect, item, sectionId, planId } = props;
  const cardList: any = useAppSelector((state) => state.app.selectedCards?.cardList);
  const [clicked, setClicked] = useState(false);
  const isCopyActionEnabled: any = useAppSelector((state) => state.app.isCopyActionEnabled);
  const [isCopyLinkSuccess, setIsCopyLinkSuccess] = useState(false);
  const { setIsOpenCopyActionDialog } = useContext(ActionCardDialogsContext);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const location = useLocation();

  const findCheckedValueById = (idToFind: number, dataArray: any) => {
    const item = dataArray.find((item: any) => item.id === idToFind);
    return item ? item.checked : null;
  };
  const checked = findCheckedValueById(item.id, cardList);

  const handleChecked = () => {
    if (clicked) dispatch(setCopyActionPopupEnabled(false));
    const dataCheck = cardList?.find((el: any) => el.id === item.id);

    if (!dataCheck) {
      const payload = {
        planId,
        sectionId,
        cardList: item
      };

      dispatch(setSelectedCards(payload));
    } else if (!checked && dataCheck && !isCopyActionEnabled) {
      dispatch(clearSelectedCards(item));
    }
  };

  const ActionCardMenu = [
    {
      label: "Copy shareable link",
      icon: CopyLink,
      action: (cardId: string) => {
        const link = planId
          ? REDIRECT_URI + "/plandetails/" + id + "/" + sectionId + "/" + cardId + "?isshareable=true"
          : REDIRECT_URI + "/library/search?q=&cardid=" + cardId;
        navigator.clipboard.writeText(link).then(function () {
          setIsCopyLinkSuccess(true);
        });
        setIsCopyLinkSuccess(false);
      },
      enabled: true
    }
  ];

  return (
    <>
      <Grid onClick={(e) => e.stopPropagation()}>
        <Feedback
          form=""
          actionStatus={{ shouldShow: isCopyLinkSuccess, variant: "success", timer: FEEDBACK_TIMER }}
          message="Link Copied"
        />
      </Grid>
      <Grid sx={{ position: "relative", height: "100%" }}>
        <Grid item xs={12} display="flex">
          {multiCardSelect ? (
            <Grid item xs={6} display="flex" onClick={(e) => e.stopPropagation()}>
              <CheckBox
                sx={{ marginLeft: "-12px" }}
                checked={cardList?.find((el: any) => el.id === item.id)}
                onChange={() => {
                  handleChecked();
                  setClicked(true);
                }}
              />
            </Grid>
          ) : (
            <Grid item xs={6} display="flex">
              <Timing color={tokens.Text.General.Secondary} duration={getHoursAndMin(timeEstimateMinutes)} />
            </Grid>
          )}

          <Grid item xs={6} display="flex" justifyContent="flex-end" onClick={(e) => e.stopPropagation()}>
            <KebabMenu value={item.id} options={ActionCardMenu} />
          </Grid>
        </Grid>
        <Grid marginTop={3} marginBottom={2}>
          <Typography
            sx={{
              overflow: "hidden",
              minHeight: "63px",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "3",
              WebkitBoxOrient: "vertical"
            }}
            variant="body2"
            color={tokens.Text.General.PrimaryHeadline}
          >
            {title}
          </Typography>
        </Grid>
        {!isAdmin && !location?.state?.redirectFromDashboard && (
          <Grid marginBottom={2} display="flex" justifyContent="end">
            <Button
              accessType={accessTypes.update}
              iconButton
              icon={CopySection}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(
                  setActiveActionCard({ planId, planType: planTypes.AllPlans, sectionId, cardId: item.id, ...item })
                );
                setIsOpenCopyActionDialog(true);
              }}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default AllPlans;
